import { Store } from 'react-notifications-component';
import CustomNoti from './customNotification';

const showMessage = (title: string, message: string, type: 'success' | 'danger' | 'info' | 'default' | 'warning') => {
    Store.addNotification({
        content: CustomNoti({ title: title, message: message, type: type }),
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 5000,
        }
    });
}

export default showMessage;
